import { render, staticRenderFns } from "./LineupTable.vue?vue&type=template&id=255df9dc&"
import script from "./LineupTable.vue?vue&type=script&lang=js&"
export * from "./LineupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports